import isObjectLike from 'lodash/isObjectLike';

import {SurveyScope} from 'client/common/types';
import cfg from 'client/common/utils/client-config';

export function stringifyValue(value: any) {
    return isObjectLike(value) ? JSON.stringify(value) : value;
}

export function createCleanLink(link: string) {
    const baseUrl = location.origin;
    const url = new URL(link, baseUrl);

    const params = new URLSearchParams(location.search);
    const selectedOrg = params.get('org');

    if (selectedOrg) {
        url.searchParams.set('org', selectedOrg);
    }

    return url.href;
}

export function createLink(
    link: string,
    relative = false,
    surveyScope: SurveyScope = SurveyScope.Yandex
): string {
    const searchParams = new URLSearchParams(location.search);
    let baseUrl = location.origin;

    if (surveyScope === SurveyScope.YandexNet || surveyScope === SurveyScope.YandexTeam) {
        baseUrl = cfg.teamEndpoint;
    }

    const url = new URL(link, baseUrl);

    for (const [key, value] of searchParams.entries()) {
        url.searchParams.append(key, value);
    }

    return relative ? `${url.pathname}${url.search}` : url.href;
}

export function openLink(link: string, newWindow = false, noOpener = true) {
    window.open(
        createLink(link),
        newWindow ? '_blank' : '_self',
        noOpener ? 'noopener,noreferrer' : undefined
    );
}

export function reload() {
    location.reload();
}
